<template>
    <footer v-bind:class="{'high__footer' : !auth}">
        <div v-if="auth" class="container">
            <div class="footer-left">
                <p>Связаться с нами!</p>
                <p><a :href="`tel:${telephone}`">{{telephone_visual}}</a></p>
                <p><a href="mailto:support-rs@sfinx.ru">support-rs@sfinx.ru</a></p>
            </div>
            <div class="footer-right">
                <a :href="linkURL" target="_blank">{{linkURL_visual}}</a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data(){
        return {
            clicomURL: "https://demo.1clicom.ru",
            localURL: "http://licexpert"
        }
    },
    computed: {
        auth(){
            return window.auth
        },
        telephone() {
            if(window.location.origin == this.clicomURL){
                return "88005004018"
            } else {
                return "88005558536"
            }
        },
        telephone_visual() {
            if(window.location.origin == this.clicomURL){
                return "8 800 500-40-18"
            } else {
                return "8 800 555-85-36 доб. 103"
            }
        },
        linkURL(){
            if(window.location.origin == this.clicomURL){
                return "http://1clicom.ru"
            } else {
                return "http://sfinx.ru"
            }
        },
        linkURL_visual(){
            if(window.location.origin == this.clicomURL){
                return "1clicom.ru"
            } else {
                return "sfinx.ru"
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import "styles/rosseti/footer.sass"

.high__footer
    padding: 50px

</style>